const pillsSpace = () => {
	if (
		!document.querySelectorAll(
			"#FacetFiltersPillsForm .active-facets__items facet-remove"
		)
	)
		return;
	const items = document.querySelectorAll(
		"#FacetFiltersPillsForm .active-facets__items facet-remove"
	);
	let currentTop = null;
	let firstInEachRow = [];

	items.forEach((item) => {
		const top = item.offsetTop;

		if (top !== currentTop) {
			firstInEachRow.push(item);
			currentTop = top;
			item.querySelector("a").classList.add("first-in-row");
		} else {
			item.querySelector("a").classList.remove("first-in-row");
		}
	});
};

// NegoStore (perf 20.10.2026): functia potriveste doar inaltimea blocurilor promo din grila. Fara ele (azi nu
// exista) nu face nimic. Ascultatorul de resize se pune o singura data si cauta blocurile din grila curenta;
// inainte fiecare filtrare adauga inca un ascultator (se adunau), legat de grila veche.
let negoSpecialResizeBound = false;
const setGridColumnsFacets = () => {
	const container = document.getElementById("ProductGridContainer");
	if (!container) return;

	const ul = container.querySelector("ul");

	if (!ul) return;

	if (!ul.querySelector("li.collection-product-card--special")) return;

	const setSpecialHeight = () => {
		const grid = document.querySelector("#ProductGridContainer ul");
		if (!grid) return;
		grid.querySelectorAll("li.collection-product-card--special").forEach((special) => {
			special.style.height = "auto";
			special.style.height =
				special.previousElementSibling !== null
					? `${special.previousElementSibling?.scrollHeight}px`
					: `${special.nextsElementSibling?.scrollHeight}px`;
		});
	};

	setSpecialHeight();
	if (negoSpecialResizeBound) return;
	negoSpecialResizeBound = true;
	window.addEventListener("resize", () =>
		setTimeout(() => setSpecialHeight(), 500)
	);
};

const updateFacetsWrapper = () => {
	if (document.querySelector(".facets__sort-wrapper") !== null) {
		const facetsWrapper = document.querySelector(".facets__sort-wrapper");
		if (facetsWrapper.querySelector("#ProductCountDesktop") !== null) {
			const countElement = facetsWrapper.querySelector("#ProductCountDesktop");
			// NegoStore (perf 09.10.2026): textContent, nu innerText. innerText forteaza un layout sincron
			// imediat dupa inlocuirea grilei; cifra citita e aceeasi (textul nu are elemente ascunse).
			const facetsCount = parseInt(countElement.textContent.match(/\d+/));
			const isZero = facetsCount == 0;

			facetsWrapper.style.display = isZero ? "none" : "flex";
		}
	}

	setTimeout(() => pillsSpace(), 500);
};

window.addEventListener("resize", () => {
	setTimeout(() => pillsSpace(), 1000);
});

class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		// NegoStore (perf 09.10.2026): bifele si sortarea (checkbox/radio) pornesc cererea dupa 150 ms;
		// 500 ms ramane doar pentru pret (tastare, slider), unde chiar trebuie asteptat sfarsitul gestului.
		// Un singur temporizator cu intarziere variabila: ultimul input inlocuieste ce era in asteptare,
		// deci nu pleaca doua cereri (si doua intrari in istoric) cand se amesteca pretul cu o bifa.
		// 150 ms aduna totusi doua atingeri rapide intr-o singura cerere. debouncedOnSubmit de mai sus ramane
		// definit (API-ul temei), dar formularul nu il mai foloseste.
		const facetForm = this.querySelector("form");
		facetForm.addEventListener("input", (event) => {
			// NegoStore (perf 09.10.2026): orice modificare noua face depasit raspunsul aflat pe drum. Altfel, un
			// raspuns sosit cat timp bifa noua isi asteapta cele 150 ms ar rescrie grupul ei de filtre (bifa s-ar
			// pierde, iar cererea ei ar pleca fara ea). Cererea care urmeaza aduce oricum starea completa.
			FacetFiltersForm.seq++;
			const type = event.target && event.target.type;
			// NegoStore (perf 20.10.2026): bifele si sortarea pleaca imediat (0 in loc de 150 ms; masurat 20.10: cele
			// 150 ms erau cel mai mare cost controlat de tema din drumul bifa -> grila de 0,55-0,84 s). Doua atingeri
			// rapide trimit acum doua cereri, dar cea veche e anulata (AbortController in renderSectionFromFetch), iar
			// updateURLHash le pune intr-o singura intrare in istoric. Temporizatorul ramane unul singur, cu 500 ms
			// pentru pret, deci o bifa inlocuieste in continuare o modificare de pret aflata in asteptare.
			const wait = type === "checkbox" || type === "radio" ? 0 : 500;
			clearTimeout(this.negoSubmitTimer);
			this.negoSubmitTimer = setTimeout(() => this.onSubmitHandler(event), wait);
		});

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		pillsSpace();
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			// NegoStore (perf 20.10.2026): dupa "Inapoi"/"Inainte" urmatoarea bifa adauga o intrare noua, nu o inlocuieste
			FacetFiltersForm.lastPush = 0;
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		// NegoStore (perf 09.10.2026): garda de secventa. Raspunsurile pot sosi in alta ordine decat
		// cererile; unul vechi intra in cache, dar nu mai suprascrie grila unei cereri mai noi.
		const seq = ++FacetFiltersForm.seq;
		// NegoStore (perf 20.10.2026): cererea aflata pe drum e depasita de cea noua (garda de secventa de mai sus
		// i-ar arunca oricum raspunsul), asa ca o anulam: serverul si reteaua lucreaza doar pentru ultima bifa.
		// AbortError se inghite; orice alta eroare ramane vizibila, ca inainte.
		FacetFiltersForm.abortPending();
		const ctrl =
			typeof AbortController === "function" ? new AbortController() : null;
		FacetFiltersForm.ctrl = ctrl;
		fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
			.then((response) => response.text())
			.then((responseText) => {
				if (FacetFiltersForm.ctrl === ctrl) FacetFiltersForm.ctrl = null;
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				if (seq !== FacetFiltersForm.seq) return;
				// NegoStore (perf 09.10.2026): raspunsul se parseaza o singura data (inainte: trei DOMParser)
				const doc = FacetFiltersForm.toDoc(html);
				FacetFiltersForm.renderFilters(doc, event);
				FacetFiltersForm.renderProductGridContainer(doc);
				FacetFiltersForm.renderProductCount(doc);
				FacetFiltersForm.renderPaginationStatus();
				setGridColumnsFacets();
			})
			.catch((error) => {
				if (error && error.name === "AbortError") return;
				throw error;
			});
	}

	// NegoStore (perf 20.10.2026): anuleaza cererea de filtrare aflata pe drum, daca exista
	static abortPending() {
		if (FacetFiltersForm.ctrl) {
			FacetFiltersForm.ctrl.abort();
			FacetFiltersForm.ctrl = null;
		}
	}

	static renderSectionFromCache(filterDataUrl, event) {
		// NegoStore (perf 09.10.2026): si randarea din cache e o cerere noua pentru garda de secventa;
		// un singur parse pentru tot raspunsul
		++FacetFiltersForm.seq;
		// NegoStore (perf 20.10.2026): o cerere mai veche aflata pe drum e depasita si de randarea din cache
		FacetFiltersForm.abortPending();
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		const doc = FacetFiltersForm.toDoc(html);
		FacetFiltersForm.renderFilters(doc, event);
		FacetFiltersForm.renderProductGridContainer(doc);
		FacetFiltersForm.renderProductCount(doc);
		FacetFiltersForm.renderPaginationStatus();
	}

	static updateImageFilterColumns() {
		const facetsList = document.querySelector(".facets__list");
		if (!facetsList) return;

		const styleAttr = facetsList.getAttribute("style");
		const match = styleAttr?.match(/--image_filter_columns:\s*(.+?);/);
		const columnValue = match?.[1]?.trim();

		if (columnValue) {
			facetsList.style.setProperty("--image_filter_columns", columnValue);
			console.log("Updated grid columns to:", columnValue);
		}
	}

	// NegoStore (perf 09.10.2026): accepta fie string (apelurile vechi), fie documentul deja parsat
	static toDoc(html) {
		return typeof html === "string"
			? new DOMParser().parseFromString(html, "text/html")
			: html;
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML = FacetFiltersForm.toDoc(html)
			.getElementById("ProductGridContainer").innerHTML;

		FacetFiltersForm.updateImageFilterColumns();

		if (
			document.querySelector(".js-load-more") ||
			document.querySelector(".js-infinite-scroll")
		) {
			loadMore();
		}

		colorSwatches();
	}

	static renderProductCount(html) {
		const count =
			FacetFiltersForm.toDoc(html)
				.getElementById("ProductCount")?.innerHTML || "0 results";
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		const containerMobile = document.querySelector(".mobile-facets__count");
		container.innerHTML = count;
		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");

			updateFacetsWrapper();
		}
		if (containerMobile) {
			containerMobile.innerHTML = count;
		}
	}

	static renderPaginationStatus() {
		const productsCount = parseInt(
			document.getElementById("ProductCountDesktop").innerHTML
		);
		const productsPerPage = parseInt(
			document.getElementById("product-grid").dataset.itemsPerPage
		);

		const totalPages = Math.ceil(productsCount / productsPerPage);
		const urlParams = new URLSearchParams(window.location.search);
		const currentPage = parseInt(urlParams.get("page")) || 1;

		const container = document.getElementById("FacetPaginationStatus");
		const currentPageElement = container.querySelector(".current-page");
		const totalPagesElement = container.querySelector(".total-pages");

		currentPageElement.textContent = currentPage;
		totalPagesElement.textContent = totalPages;
		container.classList.remove("loading");
	}

	static renderFilters(html, event) {
		const parsedHTML = FacetFiltersForm.toDoc(html);

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersForm1 .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			// NegoStore (perf 09.10.2026): un filtru care lipseste din pagina (garda din facets.liquid)
			// nu mai opreste randarea celorlalte cu o eroare
			const target = document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			);
			if (target) target.innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		// NegoStore (perf 20.10.2026): fara intarzierea de 150 ms doua bife rapide ar lasa doua intrari in istoric
		// (inainte se adunau intr-o singura cerere). O schimbare la mai putin de 1 s dupa intrarea adaugata de filtre
		// o inlocuieste (replaceState), deci "Inapoi" sare peste toata rafala, ca inainte.
		const url = `${window.location.pathname}${searchParams && "?".concat(searchParams)}`;
		const now = Date.now();
		if (now - FacetFiltersForm.lastPush < 1000) {
			history.replaceState({ searchParams }, "", url);
			return;
		}
		history.pushState({ searchParams }, "", url);
		FacetFiltersForm.lastPush = now;
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest("form").id === "FacetFiltersFormMobile";

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (
						form.id === "FacetSortForm" ||
						form.id === "FacetFiltersForm" ||
						form.id === "FacetSortDrawerForm"
					) {
						const noJsElements = document.querySelectorAll(".no-js-list");
						noJsElements.forEach((el) => el.remove());
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === "FacetFiltersFormMobile") {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join("&"), event);
		}

		updateFacetsWrapper();
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.seq = 0; // NegoStore (perf 09.10.2026): garda de secventa, vezi renderSectionFromFetch
FacetFiltersForm.ctrl = null; // NegoStore (perf 20.10.2026): AbortController-ul cererii de filtrare aflate pe drum
FacetFiltersForm.lastPush = 0; // NegoStore (perf 20.10.2026): momentul ultimei intrari puse in istoric, vezi updateURLHash
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		inputRangeWrappers.forEach((inputWrapper) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];

			const range = parseFloat(inputRangeTo.max) - parseFloat(inputRangeTo.min);
			const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
			const toCurrent = inputRangeTo.value - inputRangeTo.min;
			const minRange = (fromCurrent / range) * 100;
			const maxRange = (toCurrent / range) * 100;

			inputWrapper.setAttribute(
				"style",
				`--range-min: ${minRange}%; --range-max: ${maxRange}%`
			);

			if (
				document.getElementById("min_range") !== null &&
				document.getElementById("max_range") !== null
			) {
				document.getElementById("min_range").innerHTML = fromCurrent;
				document.getElementById("max_range").innerHTML = toCurrent;
			}

			if (
				document.getElementById("min_range1") !== null &&
				document.getElementById("max_range1") !== null
			) {
				document.getElementById("min_range1").innerHTML = fromCurrent;
				document.getElementById("max_range1").innerHTML = toCurrent;
			}

			if (
				document.getElementById("min_range2") !== null &&
				document.getElementById("max_range2") !== null
			) {
				document.getElementById("min_range2").innerHTML = fromCurrent;
				document.getElementById("max_range2").innerHTML = toCurrent;
			}
		});
	}

	controlSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputRangeWrappers.forEach((inputWrapper, index) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];
			const inputNumberFrom =
				inputNumberWrappers[index].querySelectorAll(".field__input")[0];
			const inputNumberTo =
				inputNumberWrappers[index].querySelectorAll(".field__input")[1];

			inputRangeFrom.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);

				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputNumberFrom.value = from;
				}

				this.fillSlider();
			};

			if (Number(inputRangeTo.value) <= 0) {
				inputRangeTo.style.zIndex = 2;
			} else {
				inputRangeTo.style.zIndex = 0;
			}

			inputRangeTo.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
					inputRangeTo.value = from;
				}

				if (Number(inputRangeTo.value) <= 0) {
					inputRangeTo.style.zIndex = 2;
				} else {
					inputRangeTo.style.zIndex = 0;
				}

				this.fillSlider();
			};
		});
	}

	controlInput() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputNumberWrappers.forEach((inputWrapper, index) => {
			const inputsNumber = inputWrapper.querySelectorAll(".field__input");
			const inputNumberFrom = inputsNumber[0];
			const inputNumberTo = inputsNumber[1];
			const inputRangeFrom =
				inputRangeWrappers[index].querySelectorAll(".field__range")[0];
			const inputRangeTo =
				inputRangeWrappers[index].querySelectorAll(".field__range")[1];

			inputNumberFrom.onchange = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputRangeFrom.value = from;
				}

				this.fillSlider();
			};

			inputNumberTo.onchange = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);

				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
				}

				this.fillSlider();
			};
		});
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}

customElements.define("facet-remove", FacetRemove);

if (Shopify.designMode) {
	document.addEventListener("shopify:section:load", () => {
		FacetFiltersForm.updateImageFilterColumns();
	});

	document.addEventListener("shopify:section:select", () => {
		FacetFiltersForm.updateImageFilterColumns();
	});

	document.addEventListener("shopify:block:select", () => {
		FacetFiltersForm.updateImageFilterColumns();
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const form = document.querySelector("form#FacetFiltersForm");
	const outside_tags = document.querySelector(".facets_tags");

	if (!form || !outside_tags) return;

	form.addEventListener("input", () => {
		const checked = form.querySelectorAll(
			'input[type="checkbox"]:checked, input[type="radio"]:checked'
		);
		outside_tags.style.display = checked.length > 0 ? "inline-flex" : "none";
	});

	const badge1 = document.getElementById("FacetFilterCount");

	function cleanProductCount() {
		const el = document.querySelector("#ProductCountDesktop");
		if (!el) return;

		// NegoStore (perf 09.10.2026): textContent, nu innerText (fara layout fortat; aceeasi cifra)
		const raw = el.dataset.rawCount || el.textContent;
		const digits = raw.match(/\d+/);
		if (digits) {
			el.textContent = digits[0];

			updateFacetsWrapper();
		}
	}

	// NegoStore (perf 09.10.2026): clasa 'scrolled' (umbra barei de filtre) nu se mai calculeaza cu
	// getBoundingClientRect la fiecare eveniment de scroll (layout fortat in timpul derularii), ci cu un
	// IntersectionObserver pe o santinela de 2 px lipita de marginea de sus a barei. Regula ramane cea
	// veche: umbra doar cand bara sta la marginea de sus a ecranului (top 0), nu sub headerul vizibil.
	// Pragurile 0 / 0.5 / 1 cu marginea de -1px dau un apel la top 1, 0 si -1, deci o bara care doar
	// trece (nu sta lipita) pierde clasa imediat, ca inainte.
	const popup = document.querySelector(".product-popup.filters-popup");
	if (popup && "IntersectionObserver" in window) {
		const sentinel = document.createElement("span");
		sentinel.setAttribute("aria-hidden", "true");
		sentinel.style.cssText =
			"position:absolute;top:0;left:0;width:1px;height:2px;pointer-events:none;visibility:hidden;";
		popup.appendChild(sentinel);
		new IntersectionObserver(
			(entries) => {
				const top = entries[entries.length - 1].boundingClientRect.top;
				popup.classList.toggle("scrolled", top > -1 && top < 1);
			},
			{ rootMargin: "-1px 0px 0px 0px", threshold: [0, 0.5, 1] }
		).observe(sentinel);
	} else if (popup) {
		window.addEventListener(
			"scroll",
			() => {
				popup.classList.toggle("scrolled", popup.getBoundingClientRect().top == 0);
			},
			{ passive: true }
		);
	}

	if (badge1) {
		const form1 = document.querySelector("#FacetFiltersPillsForm");

		if (!form1) return;

		const updateFacetRemoveCount = () => {
			const removeItems = form1.querySelectorAll("facet-remove");

			const badge1 = document.getElementById("FacetFilterCount");
			if (badge1) {
				badge1.textContent =
					removeItems.length > 0 ? `(${removeItems.length})` : "";
			}

			pillsSpace();
		};

		// NegoStore (perf 09.10.2026): o randare de filtre produce o rafala de mutatii in formularul de
		// pastile. Munca de mai jos (citiri de layout) se face o singura data, in cadrul urmator,
		// inainte de pictura, deci contorul si pastilele apar in acelasi cadru ca pana acum.
		let pillsFrame = 0;
		const observer = new MutationObserver(() => {
			if (pillsFrame) return;
			pillsFrame = requestAnimationFrame(() => {
				pillsFrame = 0;
				updateFacetRemoveCount();
				cleanProductCount();
				updateFacetsWrapper();
				pillsSpace();
			});
		});

		observer.observe(form1, {
			childList: true,
			subtree: true,
		});

		updateFacetRemoveCount();
		cleanProductCount();
		updateFacetsWrapper();
	}
});
